import MarkdownIt from "markdown-it";

const md = new MarkdownIt();
md.set({ html: true });

// Merge sibling `<ol>/<ul>/<ol>` runs into one nested `<ol>` so numbered sections stay 1, 2, 3.
export function normalizeOrderedLists(html) {
    if (typeof html !== "string" || typeof DOMParser === "undefined") {
        return html;
    }

    const doc = new DOMParser().parseFromString(html, "text/html");

    let node = doc.body.firstElementChild;
    while (node) {
        if (node.tagName === "OL") {
            let sibling = node.nextElementSibling;
            while (sibling && (sibling.tagName === "UL" || sibling.tagName === "OL")) {
                const next = sibling.nextElementSibling;

                if (sibling.tagName === "UL") {
                    const lastItem = node.lastElementChild;
                    if (!lastItem) {
                        break;
                    }
                    lastItem.appendChild(sibling);
                } else {
                    while (sibling.firstElementChild) {
                        node.appendChild(sibling.firstElementChild);
                    }
                    sibling.remove();
                }

                sibling = next;
            }
        }

        node = node.nextElementSibling;
    }

    return doc.body.innerHTML;
}

export function toHtml(content) {
    if (content === undefined) {
        return content;
    }

    return normalizeOrderedLists(md.render(content));
}

export default {
    toHtml,
    normalizeOrderedLists,
};
